import { SpacerValueOrKey } from "@faire/web--source/slate/spacing/getSpacing";
import { ResponsiveProp } from "@faire/web--source/slate/Theme/ResponsiveProp";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";

export const useOrderItemCardGrid = () => {
  const itemsPerRow = useResponsiveValue({
    mobileAndAbove: 1,
    tabletAndAbove: 2,
  });

  const gap = useResponsiveValue<ResponsiveProp<SpacerValueOrKey>>({
    mobileAndAbove: "2x",
    desktopAndAbove: "3x",
  });
  return {
    itemsPerRow,
    gap,
  };
};
